/**
 * ErrorIdentidad.js
 * @author Jaiván Piña
 */
 
//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { disableRiesgoNet } from '../../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//Assets
import faceError from '../../../static/img/face-error.png';

//Services
import { processToken } from './../services/tokenService';
import { processFlow } from './../services/flowService';
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class ErrorIdentidad extends Component {
    constructor(props) {
        super(props);
        this.state = { }
        this.validateFlow = this.validateFlow.bind(this);
        this.validateToken = this.validateToken.bind(this);
    }

    componentWillMount() {
        if (this.props.riesgoNetEnabled) {
            this.props.dispatch(
                disableRiesgoNet()
            );
        } else {
            this.validateFlow();
        }
        this.validateToken();
        processIdClientAnalytics('error-identidad');
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    render() {
        const footer = {
            button: {
                link: this.props.riesgoURLNet,
                text : "responder preguntas"
            }
        };
        const body = { img : { src : faceError } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >No podemos validar</h5>
                            <h5 className="title">tu identidad digitalmente</h5>
                            <h6 className="description">Para poder continuar, te haremos algunas preguntas personales.</h6>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        riesgoURLNet: state.riesgoURLNet.url,
        riesgoNetEnabled: state.riesgoNetEnabler.enable
    }
}

export default connect(mapStateToProps)(ErrorIdentidad);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorIdentidad.js